enum WorkspaceProjectAssetRegistryType {
  carbonCredits = 'carbonCredits',
  forwards = 'forwards',
  preForwards = 'preForwards',
}

export default WorkspaceProjectAssetRegistryType
